(function () {
    let slidePrevBtnArr = document.querySelectorAll('.our-manufacture__slider-btn--prev');
    let slideNextBtnArr = document.querySelectorAll('.our-manufacture__slider-btn--next');
    let curSlideNumber;

    let setSlideNum = function (evt, increment) {
        let slidesWrapEl = evt.target.parentNode.querySelector('.our-manufacture__slides-img-wrapper');
        let slidesCount = slidesWrapEl.children.length;

        curSlideNumber = slidesWrapEl.dataset.curSlideNum;

        curSlideNumber = ((+curSlideNumber) + increment + slidesCount) % slidesCount;

        slidesWrapEl.style.transform = 'translateX(-' + curSlideNumber * 100 + '%)';
        slidesWrapEl.dataset.curSlideNum = curSlideNumber;
    }

    for (let i = 0; i < slideNextBtnArr.length; i++) {
        slideNextBtnArr[i].addEventListener('click', function(evt) {
            setSlideNum(evt, 1);
        });
    }

    for (let i = 0; i < slidePrevBtnArr.length; i++) {
        slidePrevBtnArr[i].addEventListener('click', function(evt) {
            setSlideNum(evt, -1);
        });
    }
}());